<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card icon="mdi-account-outline">
          <template #after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ $t('userprofile.editprofile') }}
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="lastName"
                    class="purple-input"
                    :label="$t('userprofile.lastname')"
                    @keyup.enter="saveUserInfo"
                    @input="isSaveButtonDisabled = false"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="firstName"
                    class="purple-input"
                    :label="$t('userprofile.firstname')"
                    @keyup.enter="saveUserInfo"
                    @input="isSaveButtonDisabled = false"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="photoUrl"
                    class="purple-input"
                    :label="$t('userprofile.photourl')"
                    append-icon="mdi-image-plus"
                    @keyup.enter="saveUserInfo"
                    @input="isSaveButtonDisabled = false"
                    @click:append="showAddPhoto"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    class="purple-input"
                    :label="$t('userprofile.email')"
                    :value="email"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    class="purple-input"
                    :label="$t('userprofile.userrole')"
                    :value="role"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    class="purple-input"
                    :label="$t('userprofile.password')"
                    value="**********"
                    type="password"
                    append-icon="mdi-pencil"
                    @click:append="showChangePassword"
                    @click="showChangePassword"
                  />
                </v-col>

                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    color="success"
                    class="mr-0"
                    :disabled="isSaveButtonDisabled"
                    @click="saveUserInfo"
                  >
                    {{ $t('userprofile.update') }}
                  </v-btn>
                  <change-password
                    :show-modal-change-password="showModalChangePassword"
                    :close-modal="closeChangePassword"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
    <add-photo-modal
      :show-modal-add-photo="showModalAddPhoto"
      :close-modal="closeAddPhoto"
    />
  </v-container>
</template>

<script>
  import AddPhotoModal from './modals/addphoto.vue'
  import ChangePassword from './modals/changePassword.vue'
  export default {
    components: { AddPhotoModal, ChangePassword },
    data: () => ({
      lastName: null,
      firstName: null,
      photoUrl: null,
      email: null,
      role: null,
      isSaveButtonDisabled: true,
      showModalAddPhoto: false,
      showModalChangePassword: false,
    }),
    mounted () {
      this.lastName = this.$store.state.user.user.lastName || ''
      this.firstName = this.$store.state.user.user.firstName || ''
      this.photoUrl = this.$store.state.user.user.photoURL || ''
      if (this.$store.state.user.user.customPhotoURL) {
        this.photoUrl = this.$store.state.user.user.customPhotoURL
      }
      this.email = this.$store.state.user.user.email || ''
      this.role = this.$store.state.user.user.role || ''
    },
    methods: {
      saveUserInfo () {
        this.$store.dispatch('SAVE_USER_INFO', {
          user: this.$store.state.user,
          userInfo: {
            lastName: this.lastName,
            firstName: this.firstName,
            customPhotoURL: this.photoUrl,
          },
        })
        this.isSaveButtonDisabled = true
      },
      showAddPhoto () {
        this.showModalAddPhoto = true
      },
      closeAddPhoto () {
        this.photoUrl = this.$store.state.user.user.photoURL || ''
        if (this.$store.state.user.user.customPhotoURL) {
          this.photoUrl = this.$store.state.user.user.customPhotoURL
        }

        this.showModalAddPhoto = false
      },
      showChangePassword () {
        console.log('opening modals')
        this.showModalChangePassword = true
      },
      closeChangePassword () {
        this.showModalChangePassword = false
      },
    },
  }
</script>
